import { Helmet } from 'react-helmet-async';

const SEOHead = ({
                     title,
                     description,
                     canonicalUrl,
                     ogImage,
                     ogType = "website",
                     keywords,
                     article,
                 }) => {
    return (
        <Helmet>
            {title && <title>{String(title)}</title>}

            {description && (
                <meta name="description" content={String(description)} />
            )}

            {keywords && (
                <meta name="keywords" content={String(keywords)} />
            )}

            {canonicalUrl && (
                <link rel="canonical" href={String(canonicalUrl)} />
            )}

            {ogType && <meta property="og:type" content={ogType} />}

            {ogImage && (
                <meta property="og:image" content={String(ogImage)} />
            )}

            {/* Article meta MUST be strings */}
            {article?.publishedTime && (
                <meta
                    property="article:published_time"
                    content={String(article.publishedTime)}
                />
            )}

            {article?.modifiedTime && (
                <meta
                    property="article:modified_time"
                    content={String(article.modifiedTime)}
                />
            )}

            {article?.section && (
                <meta
                    property="article:section"
                    content={String(article.section)}
                />
            )}

            {Array.isArray(article?.tags) &&
                article.tags.map((tag, i) => (
                    <meta
                        key={i}
                        property="article:tag"
                        content={String(tag)}
                    />
                ))}
        </Helmet>
    );
};

export default SEOHead;
